/* eslint-disable no-console,no-undef,no-alert */
// This import loads the firebase namespace.
import firebase from 'firebase';

// These imports load individual services into the firebase namespace.
import 'firebase/auth';

const firebaseConfig = {
    apiKey: 'AIzaSyBu4KX7nuOC1_oP5tPcpbMCum0zkGwI1Eg',
    authDomain: 'dr-watson-cbd.firebaseapp.com',
    databaseURL: 'https://dr-watson-cbd.firebaseio.com',
    projectId: 'dr-watson-cbd',
    storageBucket: '',
    messagingSenderId: '1072212772406',
    appId: '1:1072212772406:web:a43cff5d3d8871655aba97',
};

if (typeof window !== 'undefined') {
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
}

export const logout = async () => {
    await firebase.auth().signOut().then(() => {
        console.log('Signed Out');
    }).catch((error) => {
        console.error('Sign Out Error', error);
    });
};

export const checkIfFirebaseAuthMagicLink = () => {
    if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
        // Additional state parameters can also be passed via URL.
        // This can be used to continue the user's intended action before triggering
        // the sign-in operation.
        // Get the email if available. This should be available if the user completes
        // the flow on the same device where they started it.
        let email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
            // User opened the link on a different device. To prevent session fixation
            // attacks, ask the user to provide the associated email again. For example:
            email = window.prompt('Please provide your email for confirmation');
        }
        // The client SDK will parse the code from the link for you.
        firebase.auth().signInWithEmailLink(email, window.location.href)
            .then((magicLinkResult) => {
                // Clear email from storage.
                window.localStorage.removeItem('emailForSignIn');
                // You can access the new user via result.user
                // Additional user info profile not available via:
                // result.additionalUserInfo.profile == null
                // You can check if the user is new or existing:
                // result.additionalUserInfo.isNewUser
                console.log('magicLinkResult', magicLinkResult);
            })
            .catch((magicLinkError) => {
                console.log('magicLinkError', magicLinkError);
                // Some error occurred, you can inspect the code: error.code
                // Common errors could be invalid email and invalid or expired OTPs.
            });
    }
};

export default firebase;
